import React from 'react';
import { Box, Card, CardContent, Typography, Switch } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { dimGrey } from '../../../../../mainTheme';

interface ActionCardProps {
  title: string;
  description: string;
  hasToggle?: boolean;
  isToggled?: boolean;
  hasChevron?: boolean;
  onClick?: () => void;
  onToggle?: (checked: boolean) => void;
}

export const ActionCard: React.FC<ActionCardProps> = ({
  title,
  description,
  hasToggle = false,
  isToggled = false,
  hasChevron = false,
  onClick,
  onToggle,
}) => {
  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onToggle) {
      onToggle(event.target.checked);
    }
  };

  return (
    <Card
      sx={{
        minWidth: { xs: 'none', sm: '564px' },
        cursor: hasChevron ? 'pointer' : 'default',
        '&:hover': { boxShadow: hasChevron ? 3 : 1 },
        border: '1px solid #D4D4D9',
        borderRadius: '8px',
      }}
      onClick={hasChevron ? onClick : undefined}
    >
      <CardContent
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: 2,
        }}
      >
        <Box>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: '16px',
              lineHeight: '22px',
              letterSpacing: '0.2px',
              color: dimGrey,
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              mt: 1,
              fontWeight: 500,
              fontSize: '12px',
              lineHeight: '16px',
              letterSpacing: '0px',
              color: dimGrey,
            }}
          >
            {description}
          </Typography>
        </Box>
        <Box display="flex" alignItems="center">
          {hasToggle && (
            <Switch
              checked={isToggled}
              onChange={handleToggle}
              color="secondary"
              onClick={(e) => e.stopPropagation()}
            />
          )}
          {hasChevron && <ChevronRightIcon color="action" />}
        </Box>
      </CardContent>
    </Card>
  );
};
